import axios from "axios";

import {
  reducerDeletedExpiredReports,
  reducerExpiredReportsStatus,
  reducerExpiredReports,
  reducerGetFiltersExpiredReports,
  reducerExpiredRecordsModalCreateValues,
} from "../../reducer/userReports/reducers/expiredReports";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

interface IExpiredReportsOptions {
  contract: string;
  date: string;
  expiredReport: {
    id: number;
  };
  merch: {
    employee: { id: number };
    login: "тестовый";
    status: { [key: string]: string };
  };
  pos: {
    address: string;
    chain: string;
    city: string;
    pos: { id: 83215 };
  };
  project: string;
  sv: {
    familyName: string;
    givenName: string;
  };
}

export const actionGetExpiredReports =
  (limit: number, page: number) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const store = getState();
    const filter = store.userReports.expiredReports.expiredReportsInputValues;
    try {
      const response = await axios.post(`${BASE_URL}/json/reports/expired`, {
        limit,
        page,
        ...filter,
      });

      dispatch(reducerExpiredReports({ data: response.data, limit, page: 1 }));
    } catch {
      console.log("err");
    }
  };

export const actionGetFiltersExpiredReports =
  (data: any) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const response = await axios.get(
        `${BASE_URL}/json/reports/expired/form`,
        data
      );

      dispatch(reducerGetFiltersExpiredReports({ data: response.data }));
    } catch {
      console.log("err");
    }
  };

export const actionDeleteExpiredReports =
  (data: { id: number }[]) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const store = getState();
      const expiredReports = store.userReports.expiredReports.reports;
      const count = store.userReports.expiredReports.expiredReportsCount;
      const limit = store.userReports.expiredReports.limit;

      if (data && data.length >= 1) {
        const response = await axios.delete(
          `${BASE_URL}/json/reports/expired`,
          {
            data,
          }
        );

        dispatch(
          reducerExpiredReportsStatus({
            status: response.status,
            requestPurpose: "delete",
          })
        );
        dispatch(
          reducerExpiredReports({
            data: {
              count: count,
              data: expiredReports.filter(
                (report: IExpiredReportsOptions) =>
                  !data.some(
                    (elem: { id: number }) =>
                      elem.id === report.expiredReport.id
                  )
              ),
            },
            limit,
            page: 1,
          })
        );
      } else {
        dispatch(
          reducerExpiredReportsStatus({
            status: "noData",
            requestPurpose: "delete",
          })
        );
      }

      dispatch(reducerDeletedExpiredReports([]));
    } catch (err) {
      dispatch(
        reducerExpiredReportsStatus({
          status: 0,
          requestPurpose: "delete",
        })
      );
      dispatch(reducerDeletedExpiredReports([]));
    }
  };

export const actionExportExpiredReports =
  (limit: number) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const store = getState();
      const filter = store.userReports.expiredReports.expiredReportsInputValues;

      const response = await axios.post(
        `${BASE_URL}/json/reports/expired/export`,
        {
          limit,
          page: 1,
          ...filter,
        }
      );

      dispatch(
        reducerExpiredReportsStatus({
          status: response.status,
          requestPurpose: "export",
        })
      );
    } catch (err) {
      dispatch(
        reducerExpiredReportsStatus({
          status: 0,
          requestPurpose: "export",
        })
      );
    }
  };

export const actionCreateExpiredReports =
  (data: any) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const store = getState();
      const expiredReportsModalData =
        store.userReports.expiredReports.expiredRecordsModalCreateValues;

      if (data && data.length >= 1) {
        const formattedData: any = [];
        data.map((report: { id: number }) =>
          formattedData.push({
            report: {
              id: report.id,
            },
            ...(expiredReportsModalData.projects && {
              project: { id: expiredReportsModalData.projects[0] },
            }),
            ...(expiredReportsModalData.merchs && {
              merch: { id: expiredReportsModalData.merchs[0] },
            }),
            ...(expiredReportsModalData.svs && {
              sv: { id: expiredReportsModalData.svs[0] },
            }),
            ...(expiredReportsModalData.vsv && {
              vsv: { id: expiredReportsModalData.vsv[0] },
            }),
          })
        );

        const response = await axios.post(
          `${BASE_URL}/json/reports/expired/create`,
          formattedData
        );

        dispatch(
          reducerExpiredReportsStatus({
            status: response.status,
            requestPurpose: "create",
          })
        );
        
        dispatch(
          reducerExpiredRecordsModalCreateValues({
            projects: [],
            merchs: [],
            svs: [],
            vsv: [],
          })
        );
      }
      dispatch(reducerDeletedExpiredReports([]));
    } catch (err) {
      dispatch(
        reducerExpiredReportsStatus({
          status: 0,
          requestPurpose: "create",
        })
      );
      dispatch(reducerDeletedExpiredReports([]));
    }
  };
